import { useQuery } from '@tanstack/react-query';
import { getVettingConfig, normalizeVettingConfigResponse } from '../services/vettingApplications';
import { vettingConfigQueryKeys } from './query-keys';

export const useVettingConfigQuery = (options = {}) =>
  useQuery({
    queryKey: vettingConfigQueryKeys.active(),
    queryFn: async () => {
      const result = await getVettingConfig();
      if (!result.success) {
        throw new Error(result.message || 'Failed to fetch vetting config');
      }
      return normalizeVettingConfigResponse(result.data);
    },
    ...options,
  });
